export default __webpack_public_path__ + "static/media/close.647129f7.svg";